export default __webpack_public_path__ + "static/media/docker.398b67ff.png";